import {SearchPropertyModel} from "../../../types/Search";

export type RelationsInfo = {
  properties: Array<SearchPropertyModel>;
  relations: Array<string>;
  conceptRelations: Array<string>;
}

const ROOT_OBJECT_NAME = 'Root';
const LITERAL_RANGE = 'Literal';

export const getRelationsInfo = (searchableObjects: Map<string, Array<SearchPropertyModel>>): RelationsInfo => {

  const propertiesMap: Record<string, SearchPropertyModel> = {};
  const rootProperties = searchableObjects.get(ROOT_OBJECT_NAME);
  if (rootProperties) {
    for (const property of rootProperties) {
      propertiesMap[property.name] = property;
    }
  }

  const properties = Object.values(propertiesMap);
  const relations: Array<string> = properties.filter((prop) => prop.isObject).map((prop) => prop.name);
  const conceptRelations: Array<string> = getConceptRelations(searchableObjects, properties);

  return {
    properties,
    relations,
    conceptRelations
  }
};

/**
 * Calculates the concept relation properties.
 *
 * @param searchableObjects object-properties mapping
 * @param rootProperties the properties of the root object
 * @returns {Array<string>} the concept relation properties
 */
const getConceptRelations = (searchableObjects: Map<string, Array<SearchPropertyModel>>,
                             rootProperties: Array<SearchPropertyModel>): Array<string> => {

  // TODO PLATFORM-3719 currently we are getting the properties from the ROOT objects as there is no easy way to
  // calculate the specific properties for the concept, we need to retrieve the type hierarchy somehow
  return rootProperties
    .filter((prop) => isObjectProperty(prop))
    .map((prop) => prop.name);
}

/**
 * Checks if the given property is object or scalar. The method explicitly checks the range of the property,
 * when the {@link SearchPropertyModel#isObject} returns <code>true</code>, if it is `Literal`, because the
 * lang properties are returned as object properties.
 *
 * @param {SearchPropertyModel} property to be checked
 * @returns {boolean}
 */
const isObjectProperty = (property: SearchPropertyModel) => property.isObject && property.range !== LITERAL_RANGE;
